export default __webpack_public_path__ + "static/mono-ondark-168x192-adf7adf5fdb74e6b8eb217cfc2f07f65.svg";